var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBigLief = function SvgBigLief(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 119,
    viewBox: "0 0 80 119",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8453 38.7344C41.7341 37.6558 45.0067 28.5857 43.1548 18.4759C41.303 8.36607 35.0279 1.04488 29.1392 2.12356C23.2504 3.20223 19.9778 12.2723 21.8296 22.3821C23.6815 32.4919 29.9565 39.8131 35.8453 38.7344Z",
    fill: "#5BBEAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2889 78.1241C73.6797 70.9818 76.2987 61.7019 72.1384 57.3968C67.9782 53.0917 58.6141 55.3918 51.2232 62.534C43.8323 69.6763 41.2134 78.9563 45.3736 83.2613C49.5339 87.5664 58.898 85.2664 66.2889 78.1241Z",
    fill: "#5BBEAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6731 41.2102C64.2942 34.9355 65.077 27.6664 61.4215 24.9743C57.7661 22.2822 51.0566 25.1866 46.4356 31.4613C41.8145 37.7361 41.0317 45.0051 44.6871 47.6972C48.3426 50.3893 55.052 47.4849 59.6731 41.2102Z",
    fill: "#5BBEAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9998 33.87C33.9998 37.55 38.3998 49.33 34.5598 54.04C30.7198 58.75 21.2498 57.17 13.2898 50.66C5.67978 44.45 5.65979 34.42 5.73979 30.5C5.73979 29.41 7.87978 28.38 15.4098 29.8C25.7898 31.78 25.6098 33.17 26.9998 33.87Z",
    fill: "#5BBEAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9734 82.3185C39.7613 77.6823 36.3797 68.6523 28.4205 62.1494C20.4613 55.6464 10.9384 54.133 7.15052 58.7692C3.36266 63.4053 6.74422 72.4353 14.7034 78.9382C22.6627 85.4412 32.1856 86.9546 35.9734 82.3185Z",
    fill: "#5BBEAA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.46 15.9399C35.86 32.4699 38.46 41.3099 40.66 65.5099C41.07 89.3499 41.27 100.44 41.57 117.91",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1299 38.0402L39.2399 52.3202L53.5599 33.9902",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9199 70.2002L41.0099 85.9102L57.0299 71.1802",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBigLief, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bigLief.92a6d889.svg";
export { ForwardRef as ReactComponent };